import { updateTheme, setupThemeListener } from './theme';
export const pillars = [
  { id: 'science', label: 'Science & Exploration' },
  { id: 'safety', label: 'Safety & Security' },
  { id: 'applications', label: 'Applications' },
  { id: 'support', label: 'Enabling & Support' },
  { id: 'corporate', label: 'Corporate' },
];
/**
 * ESA UI Settings Management
 */
class Settings {
  constructor() {
    this.theme = 'light';
    this.pillar = 'corporate';
    const stored = localStorage.getItem('esaUiSettings');
    if (stored) {
      const data = JSON.parse(stored);
      // NOTE: we currently don't have concerns in loading potentially
      // tampered user data, but that might change in the future, be aware.
      for (const k of Object.keys(data)) {
        this[k] = data[k];
      }
    }
    else {
      this.store();
    }
  }
  store() {
    const data = JSON.stringify(Object(this));
    localStorage.setItem('esaUiSettings', data);
  }
  /**
   * Notify of settings changes through the esaUiSettingsUpdated event
   */
  notifyChange() {
    updateTheme();
    this.store();
    window.dispatchEvent(new CustomEvent('esaUiSettingsUpdated', { detail: this }));
  }
}
const w = window;
export const settings = w.esaUiSettings || new Settings();
if (!w.esaUiSettings) {
  w.esaUiSettings = settings;
  w.esaUiSetupThemeListener = setupThemeListener;
}
